import { SVGProps } from 'react'

interface FailRectRoundedProps extends SVGProps<SVGSVGElement> {
  strokeColor?: string
}

export const FailRectRounded = ({
  strokeColor,
  width = 65,
  height = 64,
  ...props
}: FailRectRoundedProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 65 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.16667 32C3.16667 38.5271 3.51989 43.5902 4.3974 47.5387C5.26819 51.4569 6.61941 54.1122 8.50362 55.9964C10.3878 57.8806 13.0431 59.2318 16.9613 60.1026C20.9098 60.9801 25.9729 61.3333 32.5 61.3333C39.0271 61.3333 44.0902 60.9801 48.0387 60.1026C51.9569 59.2318 54.6122 57.8806 56.4964 55.9964C58.3806 54.1122 59.7318 51.4569 60.6026 47.5387C61.4801 43.5902 61.8333 38.5271 61.8333 32C61.8333 25.4729 61.4801 20.4098 60.6026 16.4613C59.7318 12.5431 58.3806 9.88783 56.4964 8.00362C54.6122 6.11941 51.9569 4.76819 48.0387 3.8974C44.0902 3.01989 39.0271 2.66667 32.5 2.66667C25.9729 2.66667 20.9098 3.01989 16.9613 3.8974C13.0431 4.76819 10.3878 6.11941 8.50362 8.00362C6.61941 9.88783 5.26819 12.5431 4.3974 16.4613C3.51989 20.4098 3.16667 25.4729 3.16667 32Z"
        stroke={strokeColor || 'black'}
        strokeWidth="5.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.5 24L32.5 32M32.5 32L24.5 40M32.5 32L40.5 40M32.5 32L24.5 24"
        stroke={strokeColor || 'black'}
        strokeWidth="5.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
